import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { VoucherModeDetailsReport as SELECT_REPORT } from 'Components/Api/VoucherAPI';
import Icon from '@material-ui/core/Icon';
import excel from 'Assets/Images/excel.svg';
import { Container, Grid, Paper, MenuItem } from '@material-ui/core';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { LOGOUT } from 'ConstComponents';
import ReactTable from 'Components/ReactTable/ReactTable';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import Accordion from '@material-ui/core/Accordion';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import { SelectByReceiverID as SELECT_PAYMENT_MODE_BYID } from 'Components/Api/PaymentModesAPI';
import { SelectByParentID as SELECT_BY_PARENT_ID } from 'Components/Api/UserBankDetailApi';
import VoucherModeBalanceAdd from './VoucherModeBalanceAdd';
const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const VoucherModeReport = () => {
    const classes = commonStyle();
    const formRef = useRef();
    const [transactions, setTransactions] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [TakeCount, setTakeCount] = useState(10);
    const [SkipCount, setSkipCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [parentBankDetails, setParentBankDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [openFilter, setopenFilter] = useState(true);
    const [openModeBalance, setopenModeBalance] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [SearchText, setSearchText] = useState('');
    const [currentUserID] = useState(localStorage.getItem('UserID'));
    const [paymentModes, setpaymentModes] = useState([]);
    const [shouldDisplayBankName, setshouldDisplayBankName] = useState(false);
    const [ModelObj] = useState({
        ToDate: new Date(),
        FromDate: new Date(),
        IsExcelDownload: false
    });
    function downloadFile(URL, Title) {
        let a = document.createElement('a');
        a.href = URL;
        a.setAttribute('download', Title);
        a.setAttribute('target', '_blank');
        a.click();
        document.removeChild(a);
    }
    const callSelectData = async (
        TakeCount,
        SkipCount,
        SearchText,
        SortColumnName,
        SortDirection
    ) => {
        let inputObj = {
            TakeCount: TakeCount,
            SkipCount: SkipCount,
            Search: SearchText,
            SortColumnName: SortColumnName,
            SortDirection: SortDirection,
            FromDate: formRef.current.values.FromDate,
            ToDate: formRef.current.values.ToDate,
            BankID: formRef.current.values.Bank,
            PaymentMode: formRef.current.values.PayMode,
            IsExcelDownload: formRef.current.values.IsExcelDownload
        };
        var requestObj = JSON.stringify(inputObj);

        setIsError(false);
        setLoading(true);

        var response = await SELECT_REPORT(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);
        if (data.IsExcelDownload) {
            formRef.current.values.IsExcelDownload = false;
            downloadFile(data.ReportPath, 'Approval Voucher Report');
        }

        setTransactions(data.list);

        setTotalCount(data.Count);
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        setTransactions([]);

        await callSelectData(TakeCount, SkipCount, '', '', '');
        setSubmitting(false);
    };

    const validationSchema = Yup.object({
        FromDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'from date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'from date')
            .typeError(PLEASE_SELECT_VALID + 'from date'),

        ToDate: Yup.date()
            .nullable(PLEASE_SELECT_VALID + 'date')
            .required(PLEASE_SELECT_VALID + 'date')
            .max(new Date(), PLEASE_SELECT_VALID + 'to date')
            .typeError(PLEASE_SELECT_VALID + 'to date')
    });

    useEffect(() => {
        createColumns();
        SelectParentBanks(currentUserID);
        setshouldDisplayBankName(false);
        selectPaymentModesWallets(currentUserID);
    }, []);

    const handlePayModeChange = (name, value, setFieldValue) => {
        setFieldValue(name, value);
        setshouldDisplayBankName(false);
        if (value === 'BankTransfer') {
            SelectParentBanks(currentUserID);
            setshouldDisplayBankName(true);
            return;
        }
        if (value === 'CashDeposit') {
            SelectParentBanks(currentUserID);
            setFieldValue('TransferBank', 'Cash');

            return;
        }
        if (value === 'Google Pay' || value === 'Phone Pe') {
            setFieldValue('TransferBank', 'Online');
            return;
        }
        setshouldDisplayBankName(false);
    };
    const selectPaymentModesWallets = async (UserID) => {
        var request = {
            UserID: UserID
        };
        var json = JSON.stringify(request);
        const response = await SELECT_PAYMENT_MODE_BYID(json);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        var data = JSON.parse(response.data);
        setpaymentModes(data);
    };
    const SelectParentBanks = async (ParentID) => {
        if (ParentID <= 0) return;
        let request = {
            ParentID: ParentID
        };
        let json = JSON.stringify(request);

        const { isAuthorized, status, data } = await SELECT_BY_PARENT_ID(json);

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        let d = JSON.parse(data);
        setParentBankDetails(d);
    };
    const SenderBankDetailList = parentBankDetails.map(
        ({ BankName, UserBankDetailsID }) => (
            <MenuItem key={UserBankDetailsID} value={UserBankDetailsID}>
                {BankName}
            </MenuItem>
        )
    );
    const BankNamesDropDown = (
        <MaterialSelect label="Select Bank" name="Bank" title="Bank">
            <MenuItem key="0" value="0">
                Select Bank
            </MenuItem>

            {SenderBankDetailList}
        </MaterialSelect>
    );
    const PayModeList = paymentModes.map(({ PaymentModeMasterID, Type }) => (
        <MenuItem key={PaymentModeMasterID} value={Type}>
            {Type}
        </MenuItem>
    ));
    const createColumns = () => {
        var columns = [];
        columns.push({
            label: 'ID',
            name: 'VoucherMasterID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'Date'
        });

        columns.push({
            label: 'ModeName',
            name: 'ModeName'
        });
        columns.push({
            label: 'OpeningBal',
            name: 'OpeningBal'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount'
        });
        columns.push({
            label: 'ClossingBal',
            name: 'ClossingBal'
        });
        columns.push({
            label: 'Credit',
            name: 'Credit'
        });
        columns.push({
            label: 'Debit',
            name: 'Debit'
        });

        columns.push({
            label: 'Remark',
            name: 'Remark'
        });

        setMainColumns(columns);
    };

    return (
        <>
            <CustomContainer
                isLoading={loading}
                isError={isError}
                alertMessage={responseMessage}
                severity={severity}
                onCloseCallback={(alertState) => {
                    setIsError(alertState);
                }}
            >
                <Grid item xs={12}>
                    <div style={{ marginBottom: '15px' }}>
                        <CustomAccordion
                            title={'Add Mode Balance'}
                            open={openModeBalance}
                            setOpen={(value) => setopenModeBalance(value)}
                        >
                            <VoucherModeBalanceAdd />
                        </CustomAccordion>
                    </div>
                </Grid>
                <Formik
                    innerRef={formRef}
                    initialValues={ModelObj}
                    validationSchema={validationSchema}
                    onSubmit={submithandle}
                    resetForm={ModelObj}
                    render={({ values, setFieldValue, handleSubmit }) => {
                        return (
                            <>
                                <Form style={{ marginBottom: '15px' }}>
                                    <Grid item xs={12}>
                                        <Paper>
                                            <CustomAccordion
                                                title={'Voucher Mode Report'}
                                                open={openFilter}
                                                setOpen={(value) =>
                                                    setopenFilter(value)
                                                }
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={2}
                                                        lg={2}
                                                    >
                                                        <MaterialDatePickerField
                                                            name="FromDate"
                                                            label="From Date"
                                                            maxDate={new Date()}
                                                        />
                                                    </Grid>

                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={2}
                                                        lg={2}
                                                    >
                                                        <MaterialDatePickerField
                                                            name="ToDate"
                                                            label="To Date"
                                                            maxDate={new Date()}
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={2}
                                                        lg={2}
                                                    >
                                                        <MaterialSelect
                                                            label="Pay Mode"
                                                            name="PayMode"
                                                            title="Select Mode"
                                                            onCustomCallback={(
                                                                name,
                                                                value
                                                            ) => {
                                                                handlePayModeChange(
                                                                    name,
                                                                    value,
                                                                    setFieldValue
                                                                );
                                                            }}
                                                        >
                                                            <MenuItem
                                                                key="0"
                                                                value="0"
                                                            >
                                                                Select Mode
                                                            </MenuItem>
                                                            {PayModeList}
                                                        </MaterialSelect>
                                                    </Grid>
                                                    {shouldDisplayBankName && (
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sm={12}
                                                            md={2}
                                                            lg={2}
                                                        >
                                                            {BankNamesDropDown}
                                                        </Grid>
                                                    )}
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={1}
                                                        lg={1}
                                                    >
                                                        <Box
                                                            style={{
                                                                textAlign:
                                                                    'center'
                                                            }}
                                                        >
                                                            <Icon
                                                                className={
                                                                    classes.CustomImageButtonStyle
                                                                }
                                                                disabled={
                                                                    loading
                                                                }
                                                                classes={{
                                                                    root:
                                                                        classes.iconRoot
                                                                }}
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    setFieldValue(
                                                                        'IsExcelDownload',
                                                                        true
                                                                    );
                                                                    handleSubmit(
                                                                        e
                                                                    );
                                                                }}
                                                            >
                                                                <img
                                                                    alt=""
                                                                    className={
                                                                        classes.imageIcon
                                                                    }
                                                                    src={excel}
                                                                />
                                                            </Icon>
                                                        </Box>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={12}
                                                        md={1}
                                                        lg={1}
                                                    >
                                                        <PrimaryButton
                                                            type="submit"
                                                            title="SEARCH"
                                                            className={
                                                                classes.CustomPrimaryButtonStyle
                                                            }
                                                            disabled={loading}
                                                            onClick={(e) => {
                                                                setFieldValue(
                                                                    'IsExcelDownload',
                                                                    false
                                                                );
                                                                handleSubmit(e);
                                                            }}
                                                        >
                                                            Search
                                                        </PrimaryButton>
                                                        {loading && (
                                                            <CircularProgress
                                                                size={24}
                                                                className={
                                                                    classes.buttonProgress
                                                                }
                                                            />
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </CustomAccordion>
                                        </Paper>
                                    </Grid>
                                </Form>
                            </>
                        );
                    }}
                />

                <ReactTable
                    data={transactions}
                    columns={mainColumns}
                    count={totalCount}
                    rowsPerPage={TakeCount}
                    serverSide={true}
                    getCallback={({ currentPage, RowsPerPage }) => {
                        setCurrentPage(currentPage);
                        setTakeCount(RowsPerPage);
                        setSkipCount(RowsPerPage * currentPage);
                        callSelectData(
                            RowsPerPage,
                            RowsPerPage * currentPage,
                            '',
                            '',
                            ''
                        );
                    }}
                    getSearchCallback={({ SearchText }) => {
                        callSelectData(
                            TakeCount,
                            currentPage,
                            SearchText,
                            '',
                            ''
                        );
                    }}
                    getSortCallback={({ column, direction }) => {
                        callSelectData(
                            TakeCount,
                            currentPage,
                            SearchText,
                            column,
                            direction
                        );
                    }}
                />
            </CustomContainer>
        </>
    );
};
